"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var toastr = require("toastr");
var app_component_1 = require("./app.component");
var common_1 = require("./common");
var components_1 = require("./components");
require("./app.scss");
function routeConfig($locationProvider, $urlRouterProvider, $stateProvider) {
    "ngInject";
    $stateProvider
        .state("app", {
        redirectTo: "app.main",
        abstract: true,
        component: "app"
    });
    $urlRouterProvider.otherwise("/");
}
function themeConfig($mdThemingProvider) {
    "ngInject";
    $mdThemingProvider.theme("default")
        .primaryPalette("blue")
        .accentPalette("red");
}
function toastrConfig() {
    toastr.options.positionClass = "toast-bottom-right";
    toastr.options.closeButton = true;
}
var App = angular
    .module("app", [
    "ui.router",
    "ngMessages",
    "ngMaterial",
    "ngAria",
    "ngAnimate",
    common_1.default.name,
    components_1.default.name
])
    .config(routeConfig)
    .config(themeConfig)
    .config(toastrConfig)
    .component("app", new app_component_1.AppComponent);
exports.default = App;



/** WEBPACK FOOTER **
 ** ./src/app/index.ts
 **/